import { render, staticRenderFns } from "./simple-header.vue?vue&type=template&id=d78735ea&"
import script from "./simple-header.vue?vue&type=script&lang=ts&"
export * from "./simple-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VSpacer,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d78735ea')) {
      api.createRecord('d78735ea', component.options)
    } else {
      api.reload('d78735ea', component.options)
    }
    module.hot.accept("./simple-header.vue?vue&type=template&id=d78735ea&", function () {
      api.rerender('d78735ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/layouts/simple-header.vue"
export default component.exports